import { ProfanityFilterEnum } from './profanity-filter.enum';

export const ProfanityFilterOptions: { value: ProfanityFilterEnum; text: string }[] = [
  {
    value: ProfanityFilterEnum.Disabled,
    text: 'Disabled'
  },
  {
    value: ProfanityFilterEnum.Flag,
    text: 'Flag'
  },
  {
    value: ProfanityFilterEnum.Block,
    text: 'Block'
  }
];
